import { axios } from '@Root/API'

export const edit = (contactId, admisionId, payload) => {
  return axios.put(`get/contact/${contactId}/admission/${admisionId}`, payload)
}
